"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WS_COUNT_VOICEMAILS = exports.SET_VOICE_MAILS_ERROR = exports.SET_VOICE_MAILS = exports.REQUEST_PATCH_VOICE_MAIL = exports.REQUEST_GET_VOICE_MAIL_MEDIA = exports.REQUEST_GET_VOICE_MAILS = exports.REQUEST_GET_VOICE_MAIL = exports.REQUEST_DELETE_VOICE_MAILS = exports.REQUEST_DELETE_VOICE_MAIL = exports.DELETE_VOICE_MAILS = void 0;
var DELETE_VOICE_MAILS = exports.DELETE_VOICE_MAILS = 'DELETE_VOICE_MAILS';
var REQUEST_DELETE_VOICE_MAIL = exports.REQUEST_DELETE_VOICE_MAIL = 'REQUEST_DELETE_VOICE_MAIL';
var REQUEST_DELETE_VOICE_MAILS = exports.REQUEST_DELETE_VOICE_MAILS = 'REQUEST_DELETE_VOICE_MAILS';
var REQUEST_GET_VOICE_MAIL = exports.REQUEST_GET_VOICE_MAIL = 'REQUEST_GET_VOICE_MAIL';
var REQUEST_GET_VOICE_MAILS = exports.REQUEST_GET_VOICE_MAILS = 'REQUEST_GET_VOICE_MAILS';
var REQUEST_GET_VOICE_MAIL_MEDIA = exports.REQUEST_GET_VOICE_MAIL_MEDIA = 'REQUEST_GET_VOICE_MAIL_MEDIA';
var REQUEST_PATCH_VOICE_MAIL = exports.REQUEST_PATCH_VOICE_MAIL = 'REQUEST_PATCH_VOICE_MAIL';
var SET_VOICE_MAILS = exports.SET_VOICE_MAILS = 'SET_VOICE_MAILS';
var SET_VOICE_MAILS_ERROR = exports.SET_VOICE_MAILS_ERROR = 'SET_VOICE_MAILS_ERROR';
var WS_COUNT_VOICEMAILS = exports.WS_COUNT_VOICEMAILS = 'WS_COUNT_VOICEMAILS';